import { FormsModule } from '@angular/forms';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import Swal from 'sweetalert2';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog"
import { CommonModule } from '@angular/common';
import { API_ENDPOINTS } from '../services/api/api-endpoints';
import { ApiService } from '../services/api/api.service';
import { LoaderComponent } from '../components/loader/loader.component';

export interface DialogData {

}

@Component({
  selector: 'app-add-review',
  imports: [FormsModule, CommonModule, LoaderComponent],
  templateUrl: './add-review.component.html',
  styleUrl: './add-review.component.scss'
})
export class AddReviewComponent {
  salon_id: string | null = null;
  stars = [1, 2, 3, 4, 5];
  description: string = "";
  rating: number = 0;
  hoverRating: number = 0;
  images: File[] = [];
  previewUrls: string[] = [];
  isLoading = false;

  constructor(private dialogRef: MatDialogRef<AddReviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private apiService: ApiService) {

    this.salon_id = data?.salon_id
  }


  setRating(rating: number) {
    this.rating = rating
  }

  setHoverRating(hoverRating: number) {
    this.hoverRating = hoverRating
  }

  handleFileSelect(event: any) {
    const files = Array.from(event.target.files) as File[];
    this.addFiles(files);
  }

  handleDragOver(event: DragEvent) {
    event.preventDefault();
  }

  handleDrop(event: DragEvent) {
    event.preventDefault();
    const files = Array.from(event.dataTransfer?.files || []);
    this.addFiles(files);
  }

  addFiles(files: File[]) {
    for (const file of files) {
      if (file.size < 5 * 1024 * 1024) {
        this.images.push(file);
        const reader = new FileReader();
        reader.onload = (e: any) => this.previewUrls.push(e.target.result);
        reader.readAsDataURL(file);
      } else {
        Swal.fire({
          title: "Error while uploading file",
          text: ("File size should be less than 5 MB."),
          icon: "error",
          timer: 5000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        })
      }
    }
  }

  removeImage(index: number) {
    this.images.splice(index, 1);
    this.previewUrls.splice(index, 1);
  }

  onClose() {
    // Handle popup close
    this.dialogRef.close()
  }


  handleSubmit() {
    const images: string[] = []
    const formData = new FormData();
    formData.append('salon_id', this.salon_id || '');
    formData.append('description', this.description);
    formData.append('rating', this.rating + "");
    this.previewUrls.forEach(url => {
      images.push(url);
    });

    const payload = {
      'salon_id': this.salon_id || '',
      'description': this.description,
      'rating': this.rating + "",
      'images': images,
    }

    this.isLoading = true;
    this.apiService.request(API_ENDPOINTS.review.addReview, "POST", payload, 'Review Added!')
      .subscribe({
        next: (response) => {
          console.log("RESPONSE", response)
          this.isLoading = false;
          this.data.afterClosed();
          this.onClose();
        },
        error: (error) => {
          console.log("error", error)
          this.isLoading = false;
        }
      })
    formData.forEach((value, key) => {
      console.log('key', key, 'value', value);
    });
    console.log("formData to submit", formData, 'images', this.images, 'desc', this.description, 'urls', this.previewUrls, 'rating', this.rating)
  }
}
